import React from 'react';
import PropTypes from 'prop-types';
import Link from '../components/link';
import convertJsonToPropsInLocale from './convert-json-to-props-in-locale';

const defaultLocale = 'en-US';

const AssetHyperlink = ({ target, children }) => {
  const transformedprops = convertJsonToPropsInLocale(target.fields, defaultLocale);
  const { file: { url } } = transformedprops;
  return <Link to={url} {...transformedprops} target="_blank">{children}</Link>;
};

AssetHyperlink.propTypes = {
  target: PropTypes.shape({
    fields: PropTypes.object.isRequired,
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default AssetHyperlink;
